// extracted by css-extract-rspack-plugin
export default {"overlayModule":"overlayModule-SPLiZc","moduleName":"moduleName-k4xhmg","moduleVersion":"moduleVersion-tgsQKR"};